var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"ot-main-panel no-gutters"},[_c('b-col',[_c('h1',[_vm._v("Page Not Found")]),_c('p',[_vm._v(" The page you requested was not found. ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }